<template>
  <va-create-layout>
    <foundations-form :title="title" :item="item"></foundations-form>
  </va-create-layout>
</template>

<script>
export default {
  props: ["title", "item"],
};
</script>
